// extracted by mini-css-extract-plugin
module.exports = {"ugc-wrapper":"ugc-m__ugc-wrapper__1re-r"};